import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface CommandCenterHeaderProps {
  title: ReactNode;
}

const CommandCenterHeader = ({ title }: CommandCenterHeaderProps) => {
  const appBarHeight = document.getElementById("app-bar")?.clientHeight;
  return (
    <Stack
      pt={2}
      gap={0.5}
      position="sticky"
      zIndex={100}
      top={appBarHeight}
      bgcolor="white"
      sx={{
        marginX: "-2px !important", // This prevents borders and shadows from showing on the left and right when scrolling
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        width={1}
        alignItems="center"
      >
        <Stack gap={1} alignItems="flex-start" overflow="hidden">
          <Stack direction="row" gap={1} alignItems="flex-start">
            <Typography variant="h5">{title}</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CommandCenterHeader;
